import { http, setFormData } from '@/utils/http'
import { SECTOR_FETCH, SECTOR_CREATE, SECTOR_UPDATE } from '@/store/actions/sector'

const state = {
  sectors: []
}

const getters = {
  sectors: state => state.sectors,
  sectorsAsOptions: state => {
    let activeSectors = state.sectors.filter(sector => sector.status === 'active')
    activeSectors = activeSectors.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
    return activeSectors.map(
      sector => ({ text: sector.name, value: sector._id })
    )
  },
  sectorName: state => (id) => { // get sector name by id
    const sector = state.sectors.find(sector => sector._id === id)
    return sector !== undefined ? sector.name : ''
  } 
}

const mutations = {
  [SECTOR_FETCH]: (state, payload) => {
    state.sectors = [ ...payload ]
  },
  [SECTOR_UPDATE]: (state, payload) => {
    const updatedSectors = [...state.sectors]
    const oldSectorIndex = updatedSectors.findIndex(
      state => (state._id === payload._id)
    )
    updatedSectors[oldSectorIndex] = Object.assign(updatedSectors[oldSectorIndex], payload)
    state.sectors = updatedSectors
  }
}

const actions = {
  [SECTOR_FETCH]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      http.get('sector/read_all')
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(SECTOR_FETCH, response.data)
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [SECTOR_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('sector/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [SECTOR_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('sector/update', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(SECTOR_UPDATE, payload)
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
